(function ($) {
    $(document).ready(function () {
        $('.language-switcher .__select select').each(function () {
            const dropdownId = $(this).parent();
        });
        
        $('#selectLanguage, #selectLanguageMobile').on('select2:select', function (e) {
            window.location = $(this).val();
            checkLanguage();
        });
        
        $("#selectLanguage, #selectLanguageMobile").select2({
            minimumResultsForSearch: Infinity,
            templateResult: formatState
        });

        checkLanguage();
    });

    function checkLanguage() {
        $('.select2-selection__rendered').each(function () {
            let language = $(this).attr('title');
            let parent = $(this).closest('.field_wrap');

            if (language === 'English' || language === 'Arabic') {
                parent.addClass('__' + language.toLowerCase());
            }
        });
    };

    function formatState(state) {
        if (!state.id) { return state.text; }
        var $state = $(
            '<div class=""></div><span>' + state.text + '</span>'
        );
        return $state;
    };
})(jQuery);
